import React from 'react';
import IconButton from 'material-ui/IconButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';

import {
    Grid,
    Icon,
} from '../../components';
import {
    salaService,
    Utils,
} from '../../services';
import PrincipalMaster from '../master/Principal';

class Salas extends React.Component {
    getSalas(filters) {
        return salaService.getAll(filters);
    }

    async getCount(filters) {
        return (await salaService.getCount(filters)).count;
    }

    async delete(codigo) {
        if (window.confirm('Deseja excluir a sala?')) {
            try {
                const _csrf = (await salaService.salaForm()).token;
                const response = await salaService.delete({ codigo, _csrf });
                Utils.showToast(response.message);
                this.salasGridRef.update();
            } catch (e) {
                Utils.showToast(e.message);
            }
        }
    }

    async newSala() {
        this.props.history.push('/salas/add');
    }

    render() {
        return (
            <PrincipalMaster title="Salas" {...this.props}>
                <div>
                    <div className="padding-content">
                        <Grid
                            ref={(ref) => { this.salasGridRef = ref; }}
                            columnSortDefault={0}
                            stripedRows="true"
                            textTableEmpty="Nenhuma sala encontrada."
                            onGetData={filters => this.getSalas(filters)}
                            onGetCount={filters => this.getCount(filters)}
                            columns={[
                                {
                                    text: 'Código', name: 'CODIGO', allowSort: true, allowSearch: true,
                                },
                                {
                                    text: 'Nome', name: 'NOME', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    name: item => (
                                        <div>
                                            <IconButton onClick={() => this.props.history.push(`/salas/add/${item.CODIGO}`)}>
                                                <Icon name="edit" />
                                            </IconButton>
                                            <IconButton onClick={() => this.delete(item.CODIGO)}>
                                                <Icon name="delete" />
                                            </IconButton>
                                        </div>
                                    ),
                                },
                            ]}
                        />
                    </div>
                    <div className="fab-buttons">
                        <FloatingActionButton onClick={() => this.newSala()}>
                            <ContentAdd />
                        </FloatingActionButton>
                    </div>
                </div>
            </PrincipalMaster>
        );
    }
}

export default Salas;
